import { Component, Input } from '@angular/core';

@Component({
  selector: 'lazy-image',
  templateUrl: './lazy-image.component.html',
  styleUrls: ['./lazy-image.component.scss']
})
export class LazyImageComponent {
  @Input() src: string;
  @Input() alt: string = '';
  @Input() placeholder: string = '../../assets/icon/default_component.jpg';
} 